export default "__VITE_ASSET__c31b9f8c__"